<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <el-form-item>
          <el-input style="width: 500px" v-model="dataForm.keyword" :placeholder="kwPlaceHolder" class="input-with-select-lg">
            <el-select v-model="dataForm.kwType" slot="prepend" placeholder="Please Select">
              <el-option v-for="item in kwTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" multiple clearable placeholder="Refund Status">
            <el-option v-for="item in refundStatusList" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.refundBusinessType" multiple clearable placeholder="Refund Order Type">
            <el-option v-for="item in orderTypeList" :key="item.value" :label="item.title" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            value-format="timestamp"
            v-model="watchApplyStartToApplyEndMillisecondTimeRange"
            type="daterange"
            range-separator="~"
            start-placeholder="Apply Start Time"
            end-placeholder="Apply End Time"
            style="width: 384px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier">
            <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 批量操作 -->
    <div id="operationArea">
      <!-- 批量退款 -->
      <el-button
        v-if="isAuth('finance:financial')"
        type="primary"
        plain
        size="small"
        icon="el-icon-thumb"
        :disabled="dataListSelections.length <= 0"
        @click="handleBatchRefund"
        class="mb16"
      >
        Batch Refund
      </el-button>
    </div>
    <div>
      <el-table
        max-height="600"
        :data="dataList"
        v-loading="dataListLoading"
        @selection-change="selectionChangeHandle"
        style="width: 100%"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
      >
        <el-table-column type="selection" align="center" width="40"></el-table-column>
        <el-table-column fixed="left" prop="businessNo" align="center" width="140" label="Transaction No."></el-table-column>
        <el-table-column align="center" label="Supplier" width="150" fixed="left">
          <template slot-scope="scope">
            <p>{{ scope.row.supplier?.abbr || "" }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="customerInvoice.invoiceNumber" align="center" width="140" label="Refund No."></el-table-column>
        <el-table-column prop="applyReason" align="center" min-width="250" label="Apply Reason"></el-table-column>
        <el-table-column prop="billingParty" align="center" label="Billing Party" min-width="200" />
        <el-table-column align="center" width="160" label="Refund Amount (Excl. Tax)">
          <template slot-scope="scope">
            <p>{{ currencyAndAmountFormat(scope.row.billingCurrency, scope.row.refundAmountExclTax) }}</p>
            <p>{{ symbolAndAmountFormat("¥", scope.row.refundAmountCnyExclTax) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="billingCurrency" align="center" label="billing Currency" width="140" />
        <el-table-column prop="createTime" align="center" width="130" label="Create Time" sortable="custom"></el-table-column>
        <el-table-column prop="finishTime" align="center" width="130" label="Finish Time" sortable="custom"></el-table-column>
        <el-table-column prop="status" align="center" width="150" label="Refund Status">
          <template slot-scope="scope">
            <p>{{ refundStatusFormat(scope.row.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="applyTime" align="center" width="190" label="Refund Create Time" sortable="custom"></el-table-column>
        <el-table-column prop="refundBusinessType" align="center" width="180" label="Refund Order Type">
          <template slot-scope="scope">
            <p>{{ orderTypeFormat(scope.row.refundBusinessType) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" width="300" label="Personnel">
          <template slot-scope="scope">
            <p v-if="scope.row.refundingTeller">Refund Teller: {{ scope.row.refundingTeller.nickname || scope.row.refundingTeller.username }}</p>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="Action" width="110">
          <template slot-scope="scope">
            <el-button @click="detailHandler(scope.row.id)" type="text" class="fwb">Detail</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>

    <!-- 批量退款 - 弹框 -->
    <batch-refund ref="batchRefundRef" @refreshDataList="getDataList()"></batch-refund>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import BatchRefund from "./modal/BatchRefund.vue";
import searchMixin from "@/mixins/searchMixin";
import tableMixin from "@/mixins/tableMixin";
import formatterMixin from "@/mixins/formatterMixin";
import paginationMixin from "@/mixins/paginationMixin.js";
import { mapState } from "vuex";
export default {
  mixins: [searchMixin, paginationMixin, tableMixin, formatterMixin],
  components: {
    BatchRefund,
    Pagination,
  },
  data() {
    return {
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      kwTypes: [
        {
          title: "Transaction No.",
          value: "businessNo",
          placeholder: "Transaction No.",
        },
        {
          title: "Refund No.",
          value: "refundNo",
          placeholder: "Refund No.",
        },
        {
          title: "Apply Reason",
          value: "applyReason",
          placeholder: "Apply Reason",
        },
      ],
      watchApplyStartToApplyEndMillisecondTimeRange: null,
      dataForm: {
        status: "",
        applyTimeStart: null,
        applyTimeEnd: null,
        refundBusinessType: null,
        kwType: "businessNo",
        keyword: "",
        supplierId: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      batchDownBtnLoading: false, // 批量导出
      supplierList: [],
    };
  },
  computed: {
    ...mapState("constant", ["orderStatusList", "refundStatusList", "payTypes", "orderTypeList", "creditStatusList"]),
    ...mapState("currency", ["currencyList"]),
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    // 批量退款
    handleBatchRefund() {
      const orderIds = [];
      this.dataListSelections.forEach(item => {
        if (item.status === "REFUNDING" || item.status === "REFUND_PENDING" || item.status === "REFUND_INFO_UPDATED") orderIds.push(item.id);
      });
      if (orderIds.length == 0) {
        this.$message.warning("You can't operate it until the filter of Refund Status is 'Refunding', 'REFUND_PENDING' or 'Refund Info Updated'.");
        return;
      }
      this.$refs.batchRefundRef.init(orderIds);
    },
    //数据请求
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        // "orders[0].asc": false,
        // "orders[0].column": "id",
        ...this.dataForm,
        [this.dataForm.kwType]: this.dataForm.keyword,
      };
      const { code, data } = await this.$http.get("/admin/orderRefundManage/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    //详情
    detailHandler(id) {
      this.$router.push(`/finance/refundOrder/${id}`);
    },
  },
  activated() {
    this.getSupplierList();
    this.getDataList();
  },
};
</script>
<style lang="scss" scoped>
.controlLeft {
  ::v-deep input {
    // border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input__inner.is-focus {
    border-color: #dcdfe6 !important;
  }

  ::v-deep .el-input:focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }

  ::v-deep .el-input.is-focus {
    .el-input__inner {
      border-color: #dcdfe6 !important;
    }
  }
}

.controlRight {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;

  ::v-deep input {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
